// extracted by mini-css-extract-plugin
export default {"PageError":"PageError_PageError__iHtYh"};